import config from '@/utils/chart/config'

export default function(code, region) {
    return /^(900|200)/.test(code) ? config.region['CNB'] : config.region[region];
}